import React, { useState } from 'react';
import { Table, TableBody } from '@mui/material';
import { MemberState } from '../../../../../types/zinantis/members/membersType';
import MembersTableSectionHeader from './MembersTableSectionHeader';
import Card from '../../../components/Card';
import MemberRow from './MemberRow';

interface MembersTableSectionProps {
    name: string;
    items: MemberState[];
}

const MembersTableSection = (props: MembersTableSectionProps) => {
    const { name, items } = props;

    const [isOpen, setIsOpen] = useState(true);
    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <Card>
            <Table size='small'>
                <MembersTableSectionHeader
                    name={name}
                    isOpen={isOpen}
                    handleToggle={handleToggle}
                />
                {isOpen ? (
                    <TableBody>
                        {items.map(member => (
                            <MemberRow key={member.id} member={member} />
                        ))}
                    </TableBody>
                ) : (
                    ''
                )}
            </Table>
        </Card>
    );
};

export default MembersTableSection;
